import React from "react";
import Modal from "material-ui/Modal";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import Typography from "material-ui/Typography";
import Icon from "material-ui/Icon";
import { RadioGroup, Radio } from "material-ui";

import {
  FormControlLabel,
} from "material-ui/Form";
import { withStyles } from "material-ui/styles";
import styles from "./styles";

import { ModalHeader, ModalContents, ModalFooter } from "../../common/modal";

class ExportJob extends React.Component {
  constructor(props) {
    super(props);
    const { job } = props;
    this.state = {
      errors: {},
	    filetype: "ZIP",
    };
  }

  onRadioChange = e => {
    let { filetype } = this.state;
    if (e.target.name === "filetype") {
      filetype = e.target.value;
    }
    this.setState({ filetype });
  };

  handleClose = () => {
    this.props.cancel();
  };

  handleSubmit = () => {
    const { filetype } = this.state;
    const { job, action } = this.props;
    let data = { };
    data.filetype = filetype;
    data.jobid = job.id;
    data.action = action;
    this.props.submit(data);
  };


  render() {
    const {
      job,
      translate,
      classes,
      action
    } = this.props;

    const {
      filetype
    } = this.state;

    return (
      <Modal open={true} onClose={this.handleClose}>
        <div className={classes.root}>
          <Paper className={classes.modal}>
            <ModalHeader>
              <Typography
                type="headline"
                color="inherit"
                className={classes.modalHeader}
              >
                {action === "download" ? translate("download_job") : translate("export_job")}
              </Typography>
  
              <Button className={classes.close} onClick={this.handleClose}>
                <Icon>clear</Icon>
              </Button>
            </ModalHeader>
            <ModalContents>
              <form noValidate autoComplete="off" className={classes.form}>
                <Typography gutterBottom color="inherit" className={classes.modalContent}>
                  {translate("select_file_type")}
                </Typography>
                <RadioGroup
                  aria-label=""
                  name="filetype"
                  value={filetype}
                  onChange={this.onRadioChange}
                  //className={classes.radioGroup}
                  className={classes.padded}
                  row={true}
                >
                  <FormControlLabel
                  value={"ZIP"}
                  control={<Radio />}
                  label={"ZIP"}
                  />
                  <FormControlLabel
                  value={"CSV"}
                  control={<Radio />}
                  label={"CSV"}
                  />
                </RadioGroup>
              </form>
            </ModalContents>

            <ModalFooter>
                <Button
                  raised
                  className={classes.submit}
                  onClick={this.handleSubmit}
                >
                  {action === "download" ? translate("download") : translate("generate_report_generate")}
                </Button>
            </ModalFooter>
          </Paper>
        </div>
      </Modal>
    );
  }
}

export default withStyles(styles)(ExportJob);



// WEBPACK FOOTER //
// ./src/components/job/exportjob/index.js